<template lang="pug">
.content(v-on-click-outside="test")
  img(:src="picked" id="pickertrigger" v-if="open == false" @click="open = true")
  .picker(v-if="open == true")
    img(v-for="char in characters" :src="char.url" @click="pickedImage(char.url)")

</template>
<script>
import { mixin as onClickOutside } from 'vue-on-click-outside'
export default {
  name: 'CharacterPicker',
  props: {
    value: {
      required: true,
    },
  },
  mixins: [onClickOutside],
  data () {
    return {
      characters: [{name: 'akuma', url: require('@/assets/img/characters/akuma.jpg')}, {name: 'alisa', url: require('@/assets/img/characters/alisa.jpg')},
      {name: 'anna', url: require('@/assets/img/characters/anna.jpg')}, {name: 'armor-king', url: require('@/assets/img/characters/armor-king.jpg')},
      {name: 'asuka', url: require('@/assets/img/characters/asuka.jpg')}, {name: 'bob', url: require('@/assets/img/characters/bob.jpg')},
      {name: 'bryan', url: require('@/assets/img/characters/bryan.jpg')}, {name: 'claudio', url: require('@/assets/img/characters/claudio.jpg')},
      {name: 'devil-jin', url: require('@/assets/img/characters/devil-jin.jpg')}, {name: 'dragunov', url: require('@/assets/img/characters/dragunov.jpg')},
      {name: 'eddy', url: require('@/assets/img/characters/eddy.jpg')}, {name: 'eliza', url: require('@/assets/img/characters/eliza.jpg')},
      {name: 'feng', url: require('@/assets/img/characters/feng.jpg')}, {name: 'geese', url: require('@/assets/img/characters/geese.jpg')},
      {name: 'gigas', url: require('@/assets/img/characters/gigas.jpg')}, {name: 'heihachi', url: require('@/assets/img/characters/heihachi.jpg')},
      {name: 'hwoarang', url: require('@/assets/img/characters/hwoarang.jpg')}, {name: 'jack7', url: require('@/assets/img/characters/jack7.jpg')},
      {name: 'jin', url: require('@/assets/img/characters/jin.jpg')}, {name: 'josie', url: require('@/assets/img/characters/josie.jpg')},
      {name: 'julia', url: require('@/assets/img/characters/julia.jpg')}, {name: 'katarina', url: require('@/assets/img/characters/katarina.jpg')},
      {name: 'kazumi', url: require('@/assets/img/characters/kazumi.jpg')}, {name: 'kazuya', url: require('@/assets/img/characters/kazuya.jpg')},
      {name: 'king', url: require('@/assets/img/characters/king.jpg')}, {name: 'kuma', url: require('@/assets/img/characters/kuma.jpg')},
      {name: 'lars', url: require('@/assets/img/characters/lars.jpg')}, {name: 'law', url: require('@/assets/img/characters/law.jpg')},
      {name: 'lee', url: require('@/assets/img/characters/lee.jpg')}, {name: 'lei', url: require('@/assets/img/characters/lei.jpg')},
      {name: 'leo', url: require('@/assets/img/characters/leo.jpg')}, {name: 'lili', url: require('@/assets/img/characters/lili.jpg')},
      {name: 'lucky-chloe', url: require('@/assets/img/characters/lucky-chloe.jpg')}, {name: 'marduk', url: require('@/assets/img/characters/marduk.jpg')},
      {name: 'master-raven', url: require('@/assets/img/characters/master-raven.jpg')}, {name: 'miguel', url: require('@/assets/img/characters/miguel.jpg')},
      {name: 'negan', url: require('@/assets/img/characters/negan.jpg')}, {name: 'nina', url: require('@/assets/img/characters/nina.jpg')},
      {name: 'noctis', url: require('@/assets/img/characters/noctis.jpg')}, {name: 'panda', url: require('@/assets/img/characters/panda.jpg')},
      {name: 'paul', url: require('@/assets/img/characters/paul.jpg')}, {name: 'shaheen', url: require('@/assets/img/characters/shaheen.jpg')},
      {name: 'steve', url: require('@/assets/img/characters/steve.jpg')}, {name: 'xiaoyu', url: require('@/assets/img/characters/xiaoyu.jpg')},
      {name: 'yoshimitsu', url: require('@/assets/img/characters/yoshimitsu.jpg')}],
      picked: undefined,
      open: false,
    }
  },
  methods: {
    pickedImage(url) {
      this.picked = url;
      this.$emit('input', url);
      this.open = false;
    },
    test() {
      this.open = false;
    }
  },
}
</script>
<style <style lang="scss" scoped>
  .picker {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: gray;
    width: 100%;
    height: 500px;
    overflow: scroll;
    z-index: 1;
    img {
      margin: 0.5%;
      width: 100px;
      height: 100px;
    }
  }
  #pickertrigger{
    background: gray;
    width: 100px;
    height: 100px;
  }
</style>
